import ServiceBase from "base/baseService"

export default class CstrService extends ServiceBase {

    title = "Código de situação tributária"
    pluralTitle = ""
    url = '/cadastro/fiscal/cstr'
    frontUrl = '/cadastro/fiscal/cstr'
    frontUrlList = '/cadastro/fiscal/cstrlist'
    primaryKey = 'codigo_cstr'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar Switch (Se não permite null?)

        // Se usar checkbox (Se permite null?)

        // Numéricos com FK notNullable

        // Strings notNullable

        data.codigo_cstr = data?.codigo_cstr || ''

        // Numéricos sem FK

        // Dependentes

        // data.cstr = data?.cstr || [] // Isso não fez sentido em Serie
        // data.classificacao_tributaria = data?.classificacao_tributaria || [] // Isso não fez sentido em Serie

        // Datas

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
